export enum CountryActionType {
    GET_LIVE_COUNTRIES = 'GET_LIVE_COUNTRIES',
    GET_LIVE_COUNTRIES_SUCCESS = 'GET_LIVE_COUNTRIES_SUCCESS',
    GET_LIVE_COUNTRIES_FAILURE = 'GET_LIVE_COUNTRIES_FAILURE'
}
